import { BBPS_COMPLAINT_STATUS } from "../../constants";

export const getStatusColor = (enabled) => {
  return enabled ? 'green.400' : 'red.400';
};

export const getComplaintStatusColor = (status) => {
  switch (status?.toUpperCase()) {
    case BBPS_COMPLAINT_STATUS.CREATED: return 'yellow.500';
    case BBPS_COMPLAINT_STATUS.SUBMITTED: return 'blue.400';
    case BBPS_COMPLAINT_STATUS.RESOLVED: return 'green.400';
    default: return 'blue.400';
  }
};